@switch (step) {
  <!-- Environnement -->
  @case (1) {
    <ng-fence-preview-environment></ng-fence-preview-environment>
  }

  <!-- Forme -->
  @case (2) {
    <ng-fence-preview-shape></ng-fence-preview-shape>
  }

  <!-- Visualisation de la clôture -->
  @case (3) {
    <ng-fence-preview-fence></ng-fence-preview-fence>
  }

  <!-- Visualisation de la clôture -->
  @case (4) {
    <ng-fence-preview-fence></ng-fence-preview-fence>
  }

  <!-- Visualisation de la clôture par type d'élément choisis -->
  @case (5) {
    <ng-fence-preview-resume></ng-fence-preview-resume>
  }
}
